module.exports = __webpack_public_path__ + "assets/img/ztoworld.ad781c9e.png";